import React, { useCallback } from 'react';
import { TouchableOpacity, View } from 'react-native';
import { hitSlopS, rem, Spacer } from 'design-system';
import Amount from 'design-system/Amount';
import IconTooltip from 'design-system/icons/IconTooltip';
import Text from 'design-system/Text';
import useStyles from 'hooks/useStyles';
import { SavingsPlanRuleType } from 'features/pots/types';
import createStyleSheets from 'utils/createStyleSheets';
import { assertUnreachable } from 'utils/types';
import AutosaveFeeInfoModal from '../AutosaveFeeInfoModal';
const getName = (type) => {
    switch (type) {
        case SavingsPlanRuleType.AUTOMATED:
            return 'AI savings';
        case SavingsPlanRuleType.CUSTOM:
            return 'Custom deposit';
        case SavingsPlanRuleType.ROUND_UP:
            return 'Round Ups';
        case 'fee':
            return 'Autosave fee';
        default:
            assertUnreachable(type);
            return '';
    }
};
const AutosaveRulePaymentRow = ({ rule }) => {
    const styles = useStyles(styleSet);
    const showFeeModal = useCallback((fee) => () => {
        AutosaveFeeInfoModal.show(fee);
    }, []);
    return (<View style={styles.container}>
      <View style={styles.infoContainer}>
        <View style={styles.nameContainer}>
          <Text TextThin-14 Secondary numberOfLines={1}>
            {getName(rule.type)}
          </Text>
          {rule.type === 'fee' && (<>
              <Spacer w={4}/>
              <TouchableOpacity hitSlop={hitSlopS} onPress={showFeeModal(rule.amount)}>
                <IconTooltip height={16} width={16} colorKey="secondary"/>
              </TouchableOpacity>
            </>)}
        </View>
        <Spacer w={16}/>
        <Amount NumbersThin-14 Secondary value={rule.amount}/>
      </View>
    </View>);
};
export default AutosaveRulePaymentRow;
const styleSet = createStyleSheets(() => ({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    flex: {
        flex: 1,
    },
    infoContainer: {
        flex: 1,
        alignItems: 'center',
        flexDirection: 'row',
        paddingVertical: rem(4),
    },
    nameContainer: {
        flex: 1,
        alignItems: 'center',
        flexDirection: 'row',
    },
}));
